var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TransientConfig_1;
import '@symon-ai/wisepipe-common'; // force import for JsonSchemaV2
import { S3File } from '@symon-ai/wisepipe-common';
import '@symon-ai/wisepipe-common-export';
import { TransientPipeExport } from '@symon-ai/wisepipe-common-export';
import { BeforeDeserialized, JSON, JsonConverter, JsonSchemaV2, MapConverter } from '@symon-ai/wisepipe-serialize';
import './transientDataConfig'; // force import for JsonSchemaV2
import { TransientDataConfig } from './transientDataConfig';
import { transientConfigSchemaValidation } from '../validations.generated';
export var DownloadFormat;
(function (DownloadFormat) {
    DownloadFormat["CSV"] = "csv";
    DownloadFormat["Parquet"] = "parquet";
})(DownloadFormat || (DownloadFormat = {}));
export const transientConfigSchema = {
    $id: 'urn:wisepipe-common-computation:TransientConfig',
    type: 'object',
    properties: {
        dataConfigMap: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-computation:TransientDataConfig' }
        },
        exportIDs: { type: 'array', items: { type: 'string', uid: 10 }, uniqueItems: true, minItems: 1 },
        exportFileMap: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common:S3File' } },
        exportConnectorMap: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-export:TransientPipeExport' }
        },
        downloadFormat: { type: 'string', enum: Object.values(DownloadFormat) }
    },
    required: ['exportIDs', 'dataConfigMap']
};
let TransientConfig = TransientConfig_1 = class TransientConfig {
    setDefaults() {
        this.downloadFormat = DownloadFormat.CSV;
        this.exportFileMap = new Map();
    }
    constructor(dataConfigMap, exportIDs, downloadFormat = 'csv', exportConnectorMap) {
        this.dataConfigMap = dataConfigMap;
        this.exportIDs = exportIDs;
        this.downloadFormat = downloadFormat;
        this.exportFileMap = new Map();
        this.exportConnectorMap = exportConnectorMap;
        JSON.validate(this, TransientConfig_1);
    }
};
__decorate([
    JsonConverter(new MapConverter(TransientDataConfig))
], TransientConfig.prototype, "dataConfigMap", void 0);
__decorate([
    JsonConverter(new MapConverter(TransientPipeExport))
], TransientConfig.prototype, "exportConnectorMap", void 0);
__decorate([
    JsonConverter(new MapConverter(S3File))
], TransientConfig.prototype, "exportFileMap", void 0);
__decorate([
    BeforeDeserialized()
], TransientConfig.prototype, "setDefaults", null);
TransientConfig = TransientConfig_1 = __decorate([
    JsonSchemaV2(transientConfigSchema, transientConfigSchemaValidation)
], TransientConfig);
export { TransientConfig };
//# sourceMappingURL=transientConfig.js.map